/* Girlgeous — carousel arrows for product carousels */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-carousel-prev], [data-carousel-next]');
    if (!btn) return;
    var section = btn.closest('.section') || document;
    var track = section.querySelector('[data-carousel]');
    if (!track) return;
    var card = track.firstElementChild;
    var step = card ? card.getBoundingClientRect().width + 20 : track.clientWidth * 0.8;
    var dir = btn.hasAttribute('data-carousel-next') ? 1 : -1;
    var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    if (dir === 1 && atEnd) { track.scrollTo({ left: 0, behavior: 'smooth' }); return; }
    track.scrollBy({ left: step * dir, behavior: 'smooth' });
  });
})();
